import { dispatchPagehome } from './page/home';
import { dispatchPageabout } from './page/about';
import { dispatchPageservice } from './page/service';
import { dispatchPostcategories } from './post/categories';
import { dispatchPosts } from './post/posts';
import { dispatchBrands } from './product/brands';
import { dispatchCategories } from './product/categories';
import { dispatchProducts } from './product/products';
import { dispatchFaqs } from './faqs';
import { dispatchLanguages } from './languages';
import { dispatchSettings } from './settings';

const initApp = () => {
  return async (dispatch, getState) => {
    const listApi = [];
    listApi.push(dispatchPagehome(dispatch, getState));
    listApi.push(dispatchPageabout(dispatch, getState));
    listApi.push(dispatchPageservice(dispatch, getState));
    listApi.push(dispatchPostcategories(dispatch, getState));
    listApi.push(dispatchPosts(dispatch, getState));
    listApi.push(dispatchBrands(dispatch, getState));
    listApi.push(dispatchCategories(dispatch, getState));
    listApi.push(dispatchProducts(dispatch, getState));
    listApi.push(dispatchFaqs(dispatch, getState));
    listApi.push(dispatchLanguages(dispatch, getState));
    listApi.push(dispatchSettings(dispatch, getState));
    try {
      await Promise.all(listApi);
    } catch (err) {
      console.error('initApp err', err);
    }
  };
};

export { initApp };



// WEBPACK FOOTER //
// ./src/actions/index.js